import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    height: 100%;
  }

  .container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .filter-buttons {
    display: flex;
    gap: var(--sds-size-space-600);
    flex-shrink: 0;
    margin-bottom: var(--sds-size-space-400);
  }

  .worlds-grid {
    min-height: 0;
    overflow: auto;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: var(--sds-size-space-600);
  }

  [slot="main-content"] {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  [slot="secondary-content"] {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .main-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
    min-height: 0;
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 12px;
    padding: var(--sds-size-space-800);
    flex: 1;
    justify-content: center;
    min-height: 300px;
  }

  .empty-state-title {
    font-family: var(--sds-typography-family-default);
    font-size: var(--sds-typography-heading-size-medium);
    font-weight: var(--sds-typography-weight-medium);
    color: var(--sds-color-text-default-primary);
    margin: 0;
  }

  .empty-state-subtitle {
    font-family: var(--sds-typography-family-default);
    font-size: var(--sds-typography-body-size-medium);
    color: var(--sds-color-text-default-secondary);
    margin: 0;
    max-width: 400px;
  }

  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--sds-size-space-800);
    color: var(--sds-color-text-default-secondary);
    font-family: var(--sds-typography-family-default);
  }

  .error {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--sds-size-space-800);
    color: var(--sds-color-text-error);
    font-family: var(--sds-typography-family-default);
  }

  .no-worlds {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--sds-size-space-800);
    color: var(--sds-color-text-default-secondary);
    font-family: var(--sds-typography-family-default);
  }

  .action-buttons {
    display: flex;
    gap: var(--sds-size-space-400);
  }

  /* Confirmation dialog styles */
  .unsaved-changes-content {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
    align-items: center;
    wow-button {
      min-width: 250px;
      --wow-button-inner-width: 100%;
    }
  }

  .info {
    margin-bottom: var(--sds-size-space-600);
  }

  .danger,
  .danger:hover {
    /* override wow-button background color */
    --sds-color-background-default-secondary: var(--sds-color-background-danger-default);
  }

  @media (max-width: 768px) {
    .worlds-grid {
      grid-template-columns: 1fr;
    }

    .empty-state {
      padding: var(--sds-size-space-600);
    }
  }
`;
